// Proactive deployment guard. Runs as a side effect at module import time and
// MUST be imported before the redux store (which triggers redux-persist
// rehydration). If the baked-in deployment id differs from the one last seen in
// this browser AND force-restart is enabled for this build, wipe localStorage +
// sessionStorage so no stale persisted auth/state is rehydrated after a deploy.
//
// VITE_DEPLOYMENT_ID / VITE_DEPLOYMENT_RESTART are baked at build time by the
// nginx Dockerfile build stage (Vite auto-exposes VITE_-prefixed env vars).

const DEPLOYMENT_ID_KEY = "__deployment_id";
const THEME_KEY = "app-theme";

const current = import.meta.env.VITE_DEPLOYMENT_ID || "dev";
const restartOn = import.meta.env.VITE_DEPLOYMENT_RESTART === "true";

if (typeof localStorage !== "undefined") {
  const stored = localStorage.getItem(DEPLOYMENT_ID_KEY);

  if (restartOn && stored && stored !== current) {
    const theme = localStorage.getItem(THEME_KEY);
    localStorage.clear();
    if (typeof sessionStorage !== "undefined") sessionStorage.clear();
    if (theme) localStorage.setItem(THEME_KEY, theme);
  }

  // Record the deployment we are running so the next load can detect a change.
  localStorage.setItem(DEPLOYMENT_ID_KEY, current);
}
